export default {
    methods: {
        format_phone_no (phoneno) {
            
            const pparam = typeof phoneno;
            if(pparam == 'number') {
                // console.log('param is number');
                phoneno = phoneno.toString();
            }

            // console.log(phoneno);
            
            let x = phoneno.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            let phone = !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
            // console.log(phone);
            return phone;
        },
    }
  };
  